import { render, staticRenderFns } from "./ModalDeliveryRequests.vue?vue&type=template&id=1f725412"
import script from "./ModalDeliveryRequests.vue?vue&type=script&lang=js"
export * from "./ModalDeliveryRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports